import { useSelector, shallowEqual } from "react-redux";
import { AccountBuckets, CashAccounts, LoanAccounts, SignedUrlAndKey, WorkbookRecords } from "./company-state";
import { AppState } from "../app-state";
import { useEffect } from "react";
import { sortStringsNumericallyThenAlphabetically } from "../../utils/common-utils";

export const useCompanyDetails = (): any[] => {
  const companyRequirements = useSelector((state: any) => state.company, shallowEqual);
  return companyRequirements;
};

export const useTeamCodes = (): any[] => {
  const allCompanyList = useSelector((state: any) => state.company.companyList, shallowEqual);
  const UserPortfolioTeamCodes = useSelector((state: any) => state.user.userTeamCodes, shallowEqual);
  const uniqueTeamCodes = [...new Set((allCompanyList || []).reduce((prev,{teamCode})=>{
    if (teamCode && !teamCode.startsWith("99")) { // Check if teamCode does not start with "99"
      prev.push(teamCode)
    }
    return prev
  },[...UserPortfolioTeamCodes]))]

    // Sort team codes: first numerically, then alphabetically
  return sortStringsNumericallyThenAlphabetically(uniqueTeamCodes);
};

export const useWorkbookRecords = (): WorkbookRecords => {
  const workbookRecords = useSelector((state: AppState) => state.company.workbookRecords, shallowEqual);

  return workbookRecords;
};

export const useTImelineRecords = (): any[] => {
  const workbookRecords = useSelector((state: AppState) => state.company.timelineRecords, shallowEqual);

  return workbookRecords;
};

export const useWorkbookSignedUrlAndKey = (): SignedUrlAndKey => {
  const workbookSignedUrlData = useSelector(
    (state: AppState) => ({
      presignedURL: state.company.workbookSignedUrl,
      activeMonthKey: state.company.activeMonthKey,
    }),
    shallowEqual
  );

  return workbookSignedUrlData;
};

export const useAccountBucketFlags = (): Omit<AccountBuckets, "sourceMappings"> => {
  const { itHasUnBucketedAccounts, workbookRefreshStatus, accountBucketInfo, isWorkBookRefreshRequired, unBucketedAccounts, isWarningDialogOpen } = useSelector((state: AppState) => state.company.accountBuckets, shallowEqual);
  return { itHasUnBucketedAccounts, workbookRefreshStatus, accountBucketInfo, isWorkBookRefreshRequired, unBucketedAccounts, isWarningDialogOpen };
};

export const useAccountMappings = (): AccountBuckets => {
  const accountMappingsRequirements = useSelector((state: any) => state.company.accountBuckets, shallowEqual);
  return accountMappingsRequirements;
};

export const useCashAccounts = (): CashAccounts => {
  const cashAccounts = useSelector((state: any) => state.company.cashAccounts, shallowEqual);
  return cashAccounts;
};
export const useLoanAccounts = (): LoanAccounts => {
  const loanAccounts = useSelector((state: any) => state.company.loanAccounts, shallowEqual);
  return loanAccounts;
};

export const useInterval = (callback: any, deps: any[], delay: number = 15000) => {
  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    callback(signal); // Trigger the callback immediately once its gets mounted.
    const timerId = setInterval(() => {
      callback(signal);
    }, delay);
    return () => {
      abortController.abort();
      clearInterval(timerId);
    };
  }, [...deps]);
};
